import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Connexion réussie");
      navigate(u.role === "admin" ? "/admin" : "/mes-transactions");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen sl-hero-bg">
      <Header />
      <div className="pt-32 pb-20">
        <div className="max-w-md mx-auto px-4">
          <h1 className="font-heading text-3xl font-bold">Connexion</h1>
          <p className="text-gray-600 mt-1">Accédez à votre historique d'envois.</p>
          <form onSubmit={submit} className="sl-card mt-6 space-y-4" data-testid="login-form">
            <div>
              <label className="sl-label">Email</label>
              <input className="sl-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
            </div>
            <div>
              <label className="sl-label">Mot de passe</label>
              <div className="relative">
                <input className="sl-input pr-11" type={showPwd ? "text" : "password"} required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
                <button type="button" onClick={() => setShowPwd((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700" aria-label={showPwd ? "Masquer le mot de passe" : "Afficher le mot de passe"} data-testid="login-password-toggle">
                  {showPwd ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading} className="sl-btn-primary w-full" data-testid="login-submit">
              {loading ? "Connexion…" : "Se connecter"}
            </button>
            <div className="text-sm text-center text-gray-500">
              Pas de compte ? <Link to="/register" className="text-[var(--sl-primary)] font-medium">S'inscrire</Link>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
